import React from 'react';
import cn from 'classnames';
import '../../../../../../../../../../styles.css';

function Loader({ messageType, typing }) {
  return (
    <div className={cn('loader', { active: typing })}>  
      {messageType}...
    </div>
  );
}

export default Loader;
